<template>
	<div class="im-role">
		<div>
			<div style="margin: 10px 0; ">
				<label style="margin-right: 10px;">最大接线量</label>
				<el-input-number v-model="params.maxChatNum"  :min="0" :max="99"></el-input-number>
			</div>
			<table-pagination ref="tableItem" v-loading="loading" :data="tableData" :column="column"  
			@selection-change="selectionChange" :total="total" :page.sync="pageNum" 
			layout="prev,pager,next,total" pagination
			:limit.sync="pageSize" @pagination="getList" >
				<template v-slot:channelNum="{row}">
					<el-input-number v-model="row.channelNum"  :min="0" :max="99"></el-input-number>
				</template>
			</table-pagination>
		</div>
		<div slot="footer" class="dialog-footer" style="text-align: right;">
		    <el-button @click="$emit('getCancelBtn')">取 消</el-button>
		    <el-button type="primary" @click="onSave">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import { saveImRoleLists } from '@/api/im'
	export default {
		props:['data'],
		watch:{
			'data':{
				handler(val){
					if(val){
						this.pageNum = 1
						this.getData();
					}
					
				},
				immediate:true
			}
		},
		data() {
			return {
				tableData:[],
				column:[
					 { label: '序号', prop: 'index', type: 'index',width:60 },
					 { label: '权限', prop: 'selection', type: 'selection' },
					 { label: '技能组权限', prop: 'skillGroupName'},
					 // { label: '接线量', prop: 'channelNum', slotScope:true },
				],
				loading:false,
				pageNum:1,
				pageSize:10,
				total:0,
				allData:[],
				multipleSelectionAll: [], // 所有选中的数据包含跨页数据
				multipleSelection: [], // 当前页选中的数据
				idKey:'skillGroup',
				params:{
					maxChatNum:0
				}
			}
		},
		methods:{
			onSave(){
				this.changePageCoreRecordData();
				// if (this.multipleSelectionAll.length <= 0) {
				// 	this.$message({
				// 		message: "无勾选数据！",
				// 		type: "warning"
				// 	});
				// 	return;
				// }
			   
			   this.multipleSelectionAll.map(item => {
				   item.enabled = true
			   })
			   this.params.agentChannelList = this.multipleSelectionAll
				this.$api.saveImRoleLists(this.data.brandIdentify,this.params).then(res => {
					if(res.errcode == 0) {
						this.$message.success('修改成功');
						this.$emit('updateImRole')
					}
				})
			},
			getData(){
				this.loading = true
				this.$api.getImRoleLists(this.data).then(res => {
					if(res.errcode == 0) {
						this.loading = false
						this.params = res.data
						this.allData = res.data.agentChannelList
						this.total = res.data.agentChannelList.length;
						let result = [];
						this.allData.map(item => {
							if(item.enabled){
								result.push(item)
							}
						})
						this.multipleSelectionAll = result
						this.setCurrentData()
					}
				})
			},
			getList(val){
				this.pageNum = val.page;
				this.changePageCoreRecordData();
				this.setCurrentData()
				
			},
			setCurrentData(){
				let begin = (this.pageNum - 1) * this.pageSize;
				let end = this.pageNum * this.pageSize;
				this.tableData = this.allData.slice(begin,end)
				setTimeout(() => {
					this.setSelectRow();
				}, 20);
			},
			selectionChange(rows){
				this.multipleSelection = rows;
			},
			changePageCoreRecordData(){
				let idKey = this.idKey;
				let that = this;
				if (this.multipleSelectionAll.length <= 0) {
					this.multipleSelectionAll = this.multipleSelection;
					return;
				}
				let selectAllIds = [];
				this.multipleSelectionAll.forEach(row => {
					selectAllIds.push(row[idKey]);
				});
				let selectIds = [];
				this.multipleSelection.forEach(row => {
					selectIds.push(row[idKey]);
					if (selectAllIds.indexOf(row[idKey]) < 0) {
						that.multipleSelectionAll.push(row);
					}
				});
				let noSelectIds = [];
				this.tableData.forEach(row => {
					if (selectIds.indexOf(row[idKey]) < 0) {
						noSelectIds.push(row[idKey]);
					}
				});
				noSelectIds.forEach(id => {
					if (selectAllIds.indexOf(id) >= 0) {
						for (let i = 0; i < that.multipleSelectionAll.length; i++) {
							if (that.multipleSelectionAll[i][idKey] == id) {
								that.multipleSelectionAll.splice(i, 1);
								break;
							}
						}
					}
				});
			},
			setSelectRow() {
				if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
					return;
				}
				// 标识当前行的唯一键的名称
				let idKey = this.idKey;
				let selectAllIds = [];
			
				this.multipleSelectionAll.forEach(row => {
					selectAllIds.push(row[idKey]);
				});
				this.$refs.tableItem.$refs.elTable.clearSelection();
				for (var i = 0; i < this.tableData.length; i++) {
					if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
						// 设置选中，记住table组件需要使用ref="table"
						this.$refs.tableItem.$refs.elTable.toggleRowSelection(this.tableData[i], true);
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.im-role {
		h3 {
			font-size: 14px;
			padding: 0 0 10px 5px;
		}
	}
</style>
